import { Injectable } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuMobileService {
  private status$ = new BehaviorSubject(false);

  constructor(private winRef: WindowRef) {}

  toggleStatus() {
    this.status$.next(!this.status$.getValue());

    if (this.status$.getValue()) {
      this.winRef.isBrowser() && this.winRef.document.body.classList.add('overflow-hidden');
    } else {
      this.closeAllMenu();
    }
  }

  close() {
    this.status$.next(false);
    this.closeAllMenu();
  }

  closeAllMenu() {
    if (this.winRef.isBrowser()) {
      this.winRef.document.body.classList.remove('overflow-hidden');
      const $actives = this.winRef.document.body.querySelectorAll('.js-menu-list');

      $actives.forEach($active => {
        $active.classList.remove('is-active');
      });
    }
  }

  status() {
    return this.status$.asObservable();
  }

  statusAsValue() {
    return this.status$.getValue();
  }
}
